import { render, staticRenderFns } from "./BaseCapability.vue?vue&type=template&id=97717f2c&scoped=true"
import script from "./BaseCapability.vue?vue&type=script&lang=js"
export * from "./BaseCapability.vue?vue&type=script&lang=js"
import style0 from "./BaseCapability.vue?vue&type=style&index=0&id=97717f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97717f2c",
  null
  
)

export default component.exports